var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RetailForm',{attrs:{"retail":_vm.retail,"buttonLoading":_vm.buttonLoading},on:{"saveRetail":_vm.saveRetail}})
}
var staticRenderFns = []

export { render, staticRenderFns }